import React from 'react';
import { AppBar, Box } from '@mui/material';

export const FormHeader = React.forwardRef((props, ref) => (
    <Box ref={ref} marginBottom={2} width="100%" sx={{ bgcolor: 'background.paper', position: 'fixed', top: 0, zIndex: 10 }}>
        <AppBar position="static" elevation={0} sx={{bgcolor: props.color || 'primary.main'}}>
            <Box p={2} align="center">
                {props.logo ? (
                    <img src={props.logo} alt="Candidate Tools Logo" style={{height: '63px'}} />
                ) : (
                    <h2>{props.idealCandidate.organizationDescriptiveName}</h2>
                )}
            </Box>
        </AppBar>
        <Box maxWidth="900px" id="form-container" sx={{ margin: '0 auto', padding: '0px 16px' }}>
            <h2>{props.idealCandidate.title} Candidate</h2>
        </Box>
    </Box>
  ));